import { Request } from 'crono-fe-common/types/request';
import axios from 'axios';
import { cookies } from 'constants/crono-cookie';
import { FeConstants } from 'constants/FeConstants';
import { isLocal } from 'utils/uiHelpers';

const client = (req: Request) => {
  const csrfToken = cookies.get(
    isLocal() ? FeConstants.cronoCsrfLocalCookie : FeConstants.cronoCsrfCookie,
  );
  const headers = {
    ...(csrfToken && isLocal()
      ? {
          'X-CSRF-TOKEN-LOCAL': csrfToken,
        }
      : {
          'X-CSRF-TOKEN': csrfToken,
        }),
    'X-Request-Source': 'FE App',
  };
  const { url, config } = req;
  return axios(`${process.env.VITE_APP_BE_URL}/${url}`, {
    ...config,
    headers: headers,
    withCredentials: true,
  }).catch(async (error: unknown) => {
    if (axios.isAxiosError(error)) {
      if (error.response?.data instanceof Blob) {
        try {
          const text = await (error.response.data as Blob).text();
          error.response.data = JSON.parse(text);
        } catch {
          // keep original Blob if parsing fails
        }
      }
      if (error.response?.status === 504) {
        error.message = 'Request timed out. Please try again.';
      } else if (!error.response && error.message === 'Network Error') {
        error.message =
          'Connection error. Please check your network and try again.';
      }
    }
    return Promise.reject(error);
  });
};

export default client;
